import mobileAdjustment from "../GeneralMobileAdjustments";

class MobilePageButtonControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }
}

const mobilePageButtonControlView = new MobilePageButtonControlView();
export default mobilePageButtonControlView